import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * PrivateRoute component to protect routes.
 * Alternative to HOC pattern - can be used directly in route definitions.
 * 
 * Usage: <Route path="/protected" element={<PrivateRoute><YourComponent /></PrivateRoute>} />
 */
const PrivateRoute = ({ children }) => {
  const { token, user } = useSelector(state => state.auth);
  const location = useLocation();

  if (!token || !user) {
    // Redirect to login, saving the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
